module.exports = __webpack_public_path__ + "img/sciencepropaganda.387a420d.jpg";